export default __webpack_public_path__ + "4dc4d7fc01ec558679857a478a862ede.jpg";